import Vue from 'vue'
import VueRouter from 'vue-router'
import pcpage from '@/components/pc/pcpage'
import home from '@/components/pc/home'
import mainpage from '@/components/pc/mainpage'
import detailpage from '@/components/pc/detailpage'
import newslist from '@/components/pc/newslist'
import news from '@/components/pc/news'
import newsdetail from '@/components/pc/newsdetail'
import timeline from '@/components/pc/timeline'
import awards from '@/components/pc/awards'
import speakers from '@/components/pc/speakers'
import history from '@/components/pc/history'
import picture from '@/components/pc/picture'
import videolist from '@/components/pc/videolist'
import resource from '@/components/pc/resource'
import topicdetail from '@/components/pc/topicdetail'
import guestdetail from '@/components/pc/guestdetail'

import m_page from '@/components/m/m_page'
import m_mainpage from '@/components/m/m_mainpage'
import m_detailpage from '@/components/m/m_detailpage'
import m_newslist from '@/components/m/m_newslist'
import m_newsdetail from '@/components/m/m_newsdetail'
import m_topicdetail from '@/components/m/m_topicdetail'
import m_guestdetail from '@/components/m/m_guestdetail'
Vue.use(VueRouter) 
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}

const router = new VueRouter({
    routes: [
        {
            path: '/',
            redirect: '/pcpage',
        },
        {
            path: '/pcpage',
            redirect: '/pcpage/mainpage/home',
            component: pcpage,
            children: [
                {
                    path: 'mainpage',
                    component: mainpage,
                    children: [
                        {
                            path: 'home',
                            component: home,
                            meta: {
                                index: 0
                            }
                        },
                        {
                            path: 'timeline',
                            component: timeline,
                            meta: {
                                index: 2
                            }
                        },
                        {
                            path: 'news',
                            component: news,
                            meta: {
                                index: 1
                            }
                        },
                        {
                            path: 'awards',
                            component: awards,
                            meta: {
                                index: 4
                            }
                        },
                        {
                            path: 'speakers',
                            component: speakers,
                            meta: {
                                index: 3
                            }
                        },
                        {
                            path: 'history',
                            component: history,
                            meta: {
                                index: 8
                            }
                        },
                        {
                            path: 'picture',
                            component: picture,
                            meta: {
                                index: 5
                            }
                        },
                        {
                            path: 'videolist',
                            component: videolist,
                            meta: {
                                index: 6
                            }
                        },
                        {
                            path: 'resource',
                            component: resource,
                            meta: {
                                index: 7
                            }
                        }
                    ]
                },
                {
                    path: 'detailpage',
                    component: detailpage,
                    redirect: '/pcpage/detailpage/newslist',
                    children: [
                        {
                            path: 'newslist',
                            component: newslist,
                            meta: {
                                index: 9
                            }
                        },
                        {
                            path: 'newsdetail',
                            component: newsdetail
                        },
                        {
                            path: 'topicdetail',
                            component: topicdetail
                        },
                        {
                            path: 'guestdetail',
                            component: guestdetail
                        },
                        
                    ]
                }
            ]
        },
        {
            path: '/m_page',
            redirect: '/m_page/m_mainpage',
            component: m_page,
            children: [
                {
                    path: 'm_mainpage',
                    component: m_mainpage
                },
                {
                    path: 'm_detailpage',
                    component: m_detailpage,
                    redirect: '/m_page/m_detailpage/m_newslist',
                    children: [
                        {
                            path: 'm_newslist',
                            component: m_newslist
                        },
                        {
                            path: 'm_newsdetail',
                            component: m_newsdetail
                        },
                        {
                            path: 'm_topicdetail',
                            component: m_topicdetail
                        },
                        {
                            path: 'm_guestdetail',
                            component: m_guestdetail
                        },
                    ]
                }
            ]
        }
    ],
})


export default router